module.exports = __webpack_public_path__ + "media/components/home/masthead/img/space_530x400-96475a6f2b70f2e903e015585a9594df.jpg";